<template>
  <div>
    错误日志
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
</style>